import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import React from 'react';
import PropTypes from 'prop-types';
import Group from './Group.js';
import Typography from './Typography.js';
import { a as addClassNames, c as classNameProps } from './classNames-6a4763fd.js';
import { a as addSpacingClasses, m as marginProps } from './spacing-d13ff368.js';
import { p as props } from './componentEl-33ff2aeb.js';

/**
This is a simple Circular Loader
*/

function LoaderBar(_ref) {
  let {
    componentEl,
    margin,
    className,
    percent,
    displayPercent,
    text,
    label,
    labelId
  } = _ref,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["componentEl", "margin", "className", "percent", "displayPercent", "text", "label", "labelId"]);

  let cssClasses = ['st_loaderbar'];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addSpacingClasses({
    margin,
    cssClasses
  });
  const ariaProps = {
    role: 'progressbar',
    'aria-valuenow': percent,
    'aria-valuemin': 0,
    'aria-valuemax': 100
  };
  if (label && labelId) ariaProps['aria-labelledby'] = labelId;
  return /*#__PURE__*/React.createElement(React.Fragment, null, label && labelId && /*#__PURE__*/React.createElement(Typography, {
    weight: "bold",
    size: "sm",
    id: labelId,
    margin: {
      bottom: 'sm'
    }
  }, label) || null, /*#__PURE__*/React.createElement(Group, _extends({
    componentEl: componentEl,
    gap: "md"
  }, ariaProps, otherProps, {
    className: cssClasses.join(' ')
  }), text && /*#__PURE__*/React.createElement(Typography, {
    size: "sm"
  }, text, "\u2026"), /*#__PURE__*/React.createElement("div", {
    className: "st_loaderbar__bar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "st_loaderbar__status",
    style: {
      width: percent + "%"
    }
  })), displayPercent && percent && /*#__PURE__*/React.createElement(Typography, {
    size: "sm"
  }, percent, "%") || null));
}

LoaderBar.propTypes = {
  /** whether to display percent done */
  displayPercent: PropTypes.bool,

  /** percent done loading */
  percent: PropTypes.number,

  /**
   * Text for "Loading…" Use an active verb to describe what the bar is accomplishing.
   * The "…" will automatically be appended */
  text: PropTypes.string,

  /** label for progressbar. Must also set `labelId`. */
  label: PropTypes.string,

  /** unique id for progressbar label, for accessibility purposes. Used for `label` */
  labelId: PropTypes.string,

  /** dom element or component to use for outermost wrapper */
  componentEl: props,

  /** extra CSS classes, if any */
  className: classNameProps,

  /** margin for component, if any */
  margin: marginProps
};
LoaderBar.defaultProps = {
  componentEl: 'div',
  className: null,
  margin: null,
  percent: 0,
  displayPercent: true,
  text: 'Loading',
  label: null,
  labelId: null
};

export default LoaderBar;
